import { render, staticRenderFns } from "./ContratItem.vue?vue&type=template&id=522cff21&"
import script from "./ContratItem.vue?vue&type=script&lang=js&"
export * from "./ContratItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports